import { redirect } from "@organizacaox/lai-design-system/router";
import { ensureActiveOrganization, refreshAuthSession } from "@/lib/auth-client";
import { queryClient, SESSION_STALE_TIME_MS } from "@/lib/query-client";
import { ApiError, getSession, sessionQueryKey } from "@/api";

export async function loadRouteSession() {
  // Começam juntas. allSettled observa também a falha do domínio quando o
  // Better Auth retorna anônimo, sem rejeição solta nem perder o redirect.
  const [authentication, domain] = await Promise.allSettled([
    refreshAuthSession(SESSION_STALE_TIME_MS),
    queryClient.fetchQuery({ queryKey: sessionQueryKey, queryFn: getSession }),
  ]);
  if (authentication.status === "rejected") throw authentication.reason;
  if (authentication.value.error) {
    if (authentication.value.error.status === 401) throw redirect({ to: "/auth" });
    throw authentication.value.error;
  }
  const data = authentication.value.data;
  if (!data?.session) throw redirect({ to: "/auth" });
  if ((data.user as { mustChangePassword?: boolean }).mustChangePassword) {
    throw redirect({ to: "/change-password" });
  }
  if (domain.status === "rejected") {
    if (domain.reason instanceof ApiError && domain.reason.status === 401) {
      queryClient.clear();
      throw redirect({ to: "/auth" });
    }
    throw domain.reason;
  }
  if (domain.value.profile?.cpfRequired) throw redirect({ to: "/complete-profile" });
  // Sem marca ativa: ativa a primeira filiação; sem nenhuma (conta criada pelo
  // Google, back#256), não há o que abrir. Admin de empresa sem marca segue.
  const { identity } = domain.value;
  if (identity.tenantId === null && identity.companyId === null) {
    if (!(await ensureActiveOrganization())) throw redirect({ to: "/no-access" });
    return queryClient.fetchQuery({ queryKey: sessionQueryKey, queryFn: getSession, staleTime: 0 });
  }
  return domain.value;
}
